import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { MoveRelatedApiModel, WorkflowStepApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class FormWorkflowService {
  public apiUrl = 'workflow-steps';

  constructor(private readonly http: HttpClientService) {}

  public add(model: WorkflowStepApiModel): Observable<WorkflowStepApiModel> {
    return this.http
      .post<WorkflowStepApiModel>(`${this.apiUrl}/add`, model)
      .pipe(map((x) => new WorkflowStepApiModel().deserialize(x)));
  }

  public update(model: WorkflowStepApiModel): Observable<WorkflowStepApiModel> {
    return this.http
      .put<WorkflowStepApiModel>(`${this.apiUrl}/update`, model)
      .pipe(map((x) => new WorkflowStepApiModel().deserialize(x)));
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }

  public move(model: MoveRelatedApiModel<number, number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }
}
